// extracted by mini-css-extract-plugin
export default {"recos":"g5-z","productCardOverride":"h5-z","rowHasBadge":"i5-z"};